module.exports = fox._r("images/menu-arr-down.png", __webpack_public_path__ + "_/_/_/common/frame/images/menu-arr-down.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/menu-arr-down.png
// module id = 128
// module chunks = 2